// Gatsby requirements
import React from 'react'

// Components
import RichText from "utils/RichTextRenderer"


const SectionText = ({ content }) => {

    return (
        <div 
            className={'text' + content._uid}
            style={{textAlign: content.alignText}}
        >

            {content?.css &&
                <style dangerouslySetInnerHTML={{__html:
                    content.css.replaceAll('.section', '.section' + content._uid).replaceAll('.text', '.text' + content._uid)
                }} />
            }

            <RichText content={content.richText} />
            
            {content.button && 
                <a href={content.button.linkUrl} className="button" id={content.button?.buttonId}>
                    {content.button.buttonText}
                </a>
            }
        </div>
    )
}

export default SectionText